import { getTicket } from "@/data/tickets";
import { TicketCard } from "./TicketCard";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

export const RelatedTickets = ({
  slugs = [],
  overline = "Compare your options",
  title = "Related tickets",
  description,
}) => {
  const tickets = slugs.map(getTicket).filter(Boolean);
  if (!tickets.length) return null;
  return (
    <section data-testid="related-tickets" className="container-tight py-16 md:py-24">
      <SectionHeading overline={overline} title={title} description={description} />
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {tickets.map((t, i) => (
          <Reveal key={t.slug} delay={i * 0.08}>
            <TicketCard ticket={t} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default RelatedTickets;
